<template>
  <div class="trade-table">
    <div class="change-type">
      <button @click="myTrade = true ; trade = false"
              :class="{'gray-btn' : myTrade === true , 'solid-gray-btn' : myTrade === false }" >
        معاملات من
      </button>
      <button @click="myTrade = false ; trade = true"
              :class="{'gray-btn' : trade === true , 'solid-gray-btn' : trade === false }">
        معاملات بازار
      </button>
    </div>
    <div class="table">
      <table>
        <tr class="sticky">
          <th class="right-text">قیمت</th>
          <th class="center-text">مقدار</th>
          <th class="left-text">زمان</th>
        </tr>

  <template v-if="myTrade">
    <tr v-for="(item , index) in tableContents" :key="index">
      <td class="number right-td" :class="{'red' : item.calculatedPriceInTomanMarket < 0 ,'green' : item.calculatedPriceInTomanMarket > 0}">{{ $toLocal(item.calculatedPriceInTomanMarket,$decimal['TOMAN']) }}</td>
      <td class="number center-td">{{ $toLocal(item.amount,8) }}</td>
      <td class="left-td">{{ $G2J(item.createdAtDateTime)}}</td>
    </tr>
  </template>

        <template v-if="trade">
          <tr v-for="(item , index) in lastTradesTable" :key="index">
            <td class="number right-td" :class="{'red' : item.calculatedPriceInTomanMarket < 0 ,'green' : item.calculatedPriceInTomanMarket > 0}">{{ $toLocal(item.calculatedPriceInTomanMarket,$decimal['TOMAN']) }}</td>
            <td class="number center-td">{{ $toLocal(item.amount,8) }}</td>
            <td class="left-td">{{ $G2J(item.createdAtDateTime)}}</td>
          </tr>
        </template>

      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "trade-table",

  data() {
    return {
      page: 0,
      lastPage:1,
      myTrade:false,
      trade:true,
      tableContents:[],
      lastTradesTable:[],
    }
  },
  methods: {
    async getLastOrders() {
      if (this.page <= this.lastPage) {

        this.$store.commit('setMarketType', `${this.$route.params.tradeFrom}_${this.$route.params.tradeTo}`)
        //for scroll loading
        this.page++ //for scroll loading
        let res = await this.$axios.get('/trades', {
          params: {
            type:'P2P',
            marketType: this.$route.params.tradeFrom + '_' + this.$route.params.tradeTo,
            page: this.page,
            size: 20
          }
        })
        // console.log(res)

        if (res.content)
          res.content = res.content.filter(i => i.orderStatus !== 'IS_OPEN');
        this.tableContents = res.content;

        this.loading = false
      }

    },
    async getLastTrades() {
      const res = await this.$axios.get('/trades/last-trades?type=P2P', {
        params: {
          marketType: this.$route.params.tradeFrom + '_' + this.$route.params.tradeTo,
          size: 20
        }
      })
      // console.log(res)
      this.lastTradesTable = res.content
      this.loading = false
    },
  },
  mounted() {
    this.getLastOrders()
    this.getLastTrades()


  },
}
</script>

<style lang="scss" scoped>
.trade-table {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 387px;

  .change-type {
    display: flex;
    justify-content: center;
    gap: 10px;

    button {
      width: 163px !important;
      height: 25px;
    }
  }

  .table {
    height: 400px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .sticky{
      position: sticky;
      top: 0;
      background-color: #0B1628;

      .right-text{
        text-align: right;
        padding-right: 13px;
      }

      .center-text{
        text-align: center;
      }

      .left-text{
        text-align: left;
        padding-left: 10px;
      }
    }

    table {
      table-layout: fixed;

      .right-td{
        text-align: right;
        padding-right: 10px;
      }

      .center-td{
        text-align: center;
      }

      .left-td{
        text-align: left;
        padding-left: 10px;
      }

      th {
        font-size: clamp(10px, 2vw, 12px);
        text-align: center;
      }

      tr {
        height: 26px;
        &:hover {
          cursor: pointer;
          background: linear-gradient(259.33deg, rgba(28, 52, 102, 0) 7.64%, rgba(28, 52, 102, 0.35) 52.12%, rgba(20, 37, 69, 0.24) 83.62%);
        }
      }

      td {
        font-size: clamp(10px, 2vw, 12px);
        text-align: center;
      }
    }
  }
}
</style>